var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._l(_vm.value, function(parseSetting, index) {
        return _c(
          "div",
          { key: index },
          [
            index !== 0
              ? _c("div", { staticClass: "text-center" }, [
                  _c("i", { staticClass: "fa fa-arrow-down" })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("HttpParseSetting", {
              attrs: { value: parseSetting },
              on: {
                input: function($event) {
                  return _vm.editSetting($event, index)
                },
                remove: function($event) {
                  return _vm.removeItem(index)
                }
              }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("button", {
        directives: [
          {
            name: "t",
            rawName: "v-t",
            value: "ADD_PARSE_STEP",
            expression: "'ADD_PARSE_STEP'"
          }
        ],
        staticClass: "btn btn-success btn-sm m-t-10",
        attrs: { type: "button" },
        on: { click: _vm.addSetting }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }